
// file dimension and size validation in from
export const fileConfigs = {
  // image in Kb
  img: {
    homeEvent:{
    uploadedfile: {
      dimension: { width: 250, height: 250},
      size: { min: 10, max: 60 },
      unit:"KB"

      }
    },
    seoContent: {                 
    uploadedfile: {                 
      dimension: { width: 1200, height: 630 },
      size: { min: 10, max: 150 },
      unit: "KB"
    }
  },
  pastEventSeo: {                 
    uploadedfile: {                 
      dimension: { width: 1200, height: 630 },
      size: { min: 10, max: 150 },
      unit: "KB"
    }
  },
    homeslider:{
      uploadedfile:{
      dimension: { width: 1200,height: 630},
      size: { min: 10, max: 100 },
      unit:"KB"
    }
    },
    testimonials:{ 
    uploadedfile:{
      dimension: { width: 300, height: 300 },
      size: { min: 15, max: 30 },
      unit:"KB"
    }},
    supportingJournals: {
      uploadedfile:{
      dimension: { width: 226,height: 317,},
      size: { min: 10, max: 100 },
      unit:"KB"
    }},
    sessions: {
      uploadedfile:{
      dimension: {width: 1200, height: 630},
      size: { min: 10, max: 100 },
      unit:"KB"
    }
  },
  mediaPartners: {
    uploadedfile:{
    dimension: {width: 200, height: 63},
    size: { min: 10, max: 30 },
    unit:"KB"
  }
},
ocm: {
      uploadedfile:{
      dimension: {width: 300, height: 300},
      size: { min: 15, max: 30 },
      unit:"KB"
    }
  },
    speakers: {
      uploadedfile:{
      dimension: {width: 300, height: 300},
      size: { min: 15, max: 30 },
      unit:"KB"
    }
  },
  pastconfgallery : {
      uploadedfile:{
      dimension: {width: 300, height: 170},
      size: { min: 10, max: 50 },
      unit:"KB"
      },
      uploadedfile1:{
        dimension: {width: 1980, height: 1080},
        size: { min: 150, max: 500 },
        unit:"KB"
        }
    },
    pastConfGallery:{
      uploadedfile:{
      dimension: {width: 300, height: 170},
      size: { min: 10, max: 50 },
      unit:"KB"
      },
      uploadedfile1:{
        dimension: {width: 1980, height: 1080},
        size: { min: 150, max: 500 },
        unit:"KB"
        }
    },
    pastconftestimonials:{
      uploadedfile:{
      dimension: {width: 300, height: 300},
      size: { min: 20, max: 30 },
      unit:"KB"
    }
  },
   pastconfproceedingsupload:{
      uploadedfile1:{ 
        dimension: {width: 200, height: 280},
        size: {min:30, max: 60},
        unit:"KB"
      }
    },
   venue:{
      uploadedfile:{ 
        dimension: {width: 250, height: 250},
        size: {min:15, max: 60},
        unit:"KB"
       }
    },
    seoSchemaMarkup:{
    uploadedfile:{
    dimension: {width: 1200, height: 630},
    size: { min:10, max: 150},  //0.01953125 = 10kb
    unit: 'MB'
    }  
  },
  seoOpenGraphProtocol:{
      uploadedfile:{
      dimension: {width: 1200, height: 630}, //0.01953125 = 10kb
      size: { min:0.0195, max: 1},
      unit: 'MB'
      }
    },
     seoTwitterCard:{
      uploadedfile:{
      dimension: {width: 1080, height: 1080}, //0.01953125 = 10kb
      size: { min:0.0195, max: 1},
      unit: 'MB'
      }
    },
  },

  // pdf in Mb
  pdf: {
    scientificProgram:{
      uploadedfile:{ size: {min: 0.9905, max: 8 },
      unit:"MB" 
    }
    },
    webinarProgram:{
    uploadedfile:{ size: {min:1, max: 8 },
    unit:"MB"
  }
   },
   brochureuploads:{
    uploadedfile:{ size: {min:1, max: 8 },
    unit:"MB"
  }
   },
   abstractUpload:{
    uploadedfile:{ size: {min:1, max: 8 },
    unit:"MB"
  }
   },
   pastconfproceedingsupload:
   {
    uploadedfile:{ size: {min:1, max: 8}, 
    unit:"MB"
  },
   },
   seoSchemaMarkup:{
    uploadedfile:{
    dimension: {width: 1980, height: 1080},
    size: { min: 0.0125, max: 8},
    unit:"MB"
    }
    },
    seoOpenGraphProtocol:{
      uploadedfile:{
      dimension: {width: 1200, height: 627},
      size: { min: 0.0175, max: 6},
      unit:"MB"
      }
    },
    seoTwitterCard:{
      uploadedfile:{
      dimension: {width: 1080, height: 1080},
      size: { min: 1, max: 1},
      unit:"MB"
      }
    },
  },
  word:{
  abstractUpload:{
      uploadedfile:{ size: {min:0.0195, max: 8 },   //0.01953125 = 10kb
      unit:"MB"
      }
   },
  }
};